import * as React from 'react';
/**
 * @hidden
 */
export var useRtl = function (elementRef, initialDir) {
    // Dir prop is read only on initial rendering due to specifics of getComputedStyles - see below
    var _a = React.useState(initialDir), rtl = _a[0], setRtl = _a[1];
    React.useEffect(function () {
        if (!rtl && window && elementRef.current) {
            // Note: getComputedStyle forces reflow
            var rtlCandidate = window.getComputedStyle(elementRef.current).direction;
            if (rtlCandidate) {
                // rerender is needed as DOM is read after first render
                setRtl(rtlCandidate);
            }
        }
    }, []);
    return rtl;
};
//# sourceMappingURL=hooks.js.map